/* eslint-disable */
import React, { Component } from 'react';
import { Link } from 'react-router-dom-latest';
import { getStorageData, getCpaPreferences } from 'utilities/utils';
import Adobe from './Adobe';
import Karbon from './Karbon';
import KarbonManualSync from './KarbonManualSync';
import Quickbooks from './Quickbooks_updated';
import Gruntworx from './Gruntworx';
import './integrations.scss';

const excludedIntegrationKeys = ['adobe'];

/**
 * @deprecated We're moving towards using the new integration modules
 * at src/components/Integrations/IntegrationsLandingPage.tsx
 */
class Integrations extends Component {
  constructor(props) {
    super(props);
    const parsedUrl = new URL(window.location.href);
    const tab = parsedUrl.searchParams.get('tab');
    let header = 'Integrations';
    let syncTab = '';
    if (
      tab &&
      (tab === 'liscio_karbon_accounts' || tab === 'liscio_karbon_contacts')
    ) {
      header = 'Liscio <=> Karbonhq';
      syncTab = tab;
    }
    this.state = {
      loading: true,
      header,
      syncTab,
      preferences: getCpaPreferences(),
      isUnauthorized: false,
    };
  }

  componentDidMount() {
    document.title = 'Integrations';
    // TODO: __HOMEDATA-AUDIT
    if (getStorageData() && getStorageData().role !== 'firm_admin') {
      this.setState({ isUnauthorized: true });
    } else {
      const { header, syncTab } = this.state;
      if (header && header === 'Liscio <=> Karbonhq' && syncTab) {
        this.props.navigate('/integrations?tab=' + syncTab);
      }
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { match, history } = this.props;
    // TODO: history.action needs to be converted to react router v6

    // if (match && match.url === '/integrations' && history.action === 'POP') {
    //   this.setState({ loading: true }, () => {
    //     this.syncData('');
    //   });
    // }
  }

  syncData = (data) => {
    this.setState({
      header: data ? 'Liscio <=> Karbonhq' : 'Integrations',
      syncTab: data,
    });
    const tb = data === '' ? '' : `?tab=${data}`;
    this.props.navigate('/integrations' + tb);
  };

  handleRoute = () => {
    this.props.navigate('/');
  };

  handleIntegrationApps = (each) => {
    let page = null;
    if (each.key === 'adobe') {
      page = <Adobe integrationAppsPref={each} />;
    }
    if (each.key === 'karbon') {
      page = <Karbon syncData={this.syncData} integrationAppsPref={each} />;
    }
    if (each.key === 'quickbooks') {
      page = <Quickbooks integrationAppsPref={each} />;
    }
    if (each.key === 'gruntworx') {
      page = <Gruntworx integrationAppsPref={each} />;
    }
    return page;
  };

  render() {
    const { header, preferences, isUnauthorized } = this.state;

    if (isUnauthorized) {
      return (
        <div id="content">
          <header>
            <h1 className="pageHeading">Integrations</h1>
          </header>
          <div className="integrations-container">
            <div
              className="emptyBox text-center"
              style={{ padding: '3rem 2rem' }}
            >
              <div className="onlyText">
                <h5 className="mb-3" style={{ color: 'darkgrey' }}>
                  This is for administrators only.
                </h5>
                <p className="text-body">
                  If you believe this is an error, please contact your
                  administrator or{' '}
                  <a href="mailto:support@liscio.me" className="link">
                    support@liscio.me
                  </a>
                  .
                </p>
              </div>
            </div>
          </div>
        </div>
      );
    }

    const karbonHeader = (
      <div className="d-block">
        <ul className="breadcrumb">
          <li className="breadcrumb-item">
            <a onClick={() => this.syncData('')}>
              <i className="icon-left-arrow label-small" aria-hidden="true" />
              {'Integrations'.toUpperCase()} /
            </a>{' '}
            {'Liscio <=> Karbonhq'}
          </li>
        </ul>
      </div>
    );
    return (
      <div id="content">
        <header>
          {header === 'Liscio <=> Karbonhq' ? (
            karbonHeader
          ) : (
            <h1 className="pageHeading">{header}</h1>
          )}
        </header>
        {header === 'Liscio <=> Karbonhq' ? (
          <KarbonManualSync
            syncData={this.syncData}
            data={this.state}
            handleRoute={this.handleRoute}
          />
        ) : (
          <div className="integrations-container">
            <div className="integrations-page__header">
              <p className="integrations-page__description">
                Manage all account-wide integrations from one place. Only Admins
                can access and modify these settings.
              </p>
              <p className="integrations-page__description">
                For individual application integrations,{' '}
                <Link
                  to="/profile_settings?tab=third_party_apps"
                  className="link"
                >
                  go here
                </Link>
                .
              </p>
            </div>
            {preferences &&
            preferences.integration_app &&
            preferences.integration_app.length ? (
              <div className="row align-items-stretch">
                {preferences.integration_app
                  .filter((each) => !excludedIntegrationKeys.includes(each.key))
                  .map((each) => this.handleIntegrationApps(each))}
              </div>
            ) : null}
          </div>
        )}
      </div>
    );
  }
}

export default Integrations;
